<template>
  <div v-if="!loading && loadTable">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PartyInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl">
              <vs-table :data="returnedOrder" ref="table">
                <template slot="thead">
                  <vs-th style="width: 15%">{{ $t("Name") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PartyType") }}</vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="
                      returnedOrder.returnOrderPartyInfoQueryDto.partyType ==
                        'Individual'
                    "
                  >
                    {{ $t("SocialSecurityNumber") }}
                  </vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="
                      returnedOrder.returnOrderPartyInfoQueryDto.partyType ==
                        'Legal'
                    "
                  >
                    {{ $t("CompanyNationalId") }}
                  </vs-th>
                  <vs-th style="width: 15%">{{ $t("PhoneNumber") }}</vs-th>
                  <vs-th style="width: 25%">{{ $t("Address") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PostalCode") }}</vs-th>
                </template>
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ returnedOrder.returnOrderPartyInfoQueryDto.name }}
                    </vs-td>
                    <vs-td>
                      <span
                        v-if="
                          returnedOrder.returnOrderPartyInfoQueryDto
                            .partyType == 'Individual'
                        "
                        >{{ $t("Individual") }}</span
                      >
                      <span
                        v-if="
                          returnedOrder.returnOrderPartyInfoQueryDto
                            .partyType == 'Legal'
                        "
                        >{{ $t("Legal") }}</span
                      >
                    </vs-td>
                    <vs-td
                      v-if="
                        returnedOrder.returnOrderPartyInfoQueryDto.partyType ==
                          'Individual'
                      "
                    >
                      <span
                        v-if="
                          !returnedOrder.returnOrderPartyInfoQueryDto
                            .socialSecurityNumber
                        "
                      >
                        -
                      </span>
                      {{
                        returnedOrder.returnOrderPartyInfoQueryDto
                          .socialSecurityNumber
                      }}
                    </vs-td>
                    <vs-td
                      v-if="
                        returnedOrder.returnOrderPartyInfoQueryDto.partyType ==
                          'Legal'
                      "
                    >
                      <span
                        v-if="
                          !returnedOrder.returnOrderPartyInfoQueryDto
                            .companyNationalId
                        "
                      >
                        -
                      </span>
                      {{
                        returnedOrder.returnOrderPartyInfoQueryDto
                          .companyNationalId
                      }}
                    </vs-td>
                    <template
                      v-for="item in returnedOrder.returnOrderPartyInfoQueryDto
                        .returnOrderPhonesQuery"
                    >
                      <td :key="item.id" style="direction: ltr">
                        <span v-if="item.area">{{ item.area }}-</span>
                        {{ item.number }}
                      </td>
                    </template>
                    <template
                      v-for="item in returnedOrder.returnOrderPartyInfoQueryDto
                        .returnOrderAddressesInfoQuery"
                    >
                      <td :key="item.id">
                        {{ item.returnOrderProvinceInfoQuery.name }}-{{
                          item.returnOrderProvinceInfoQuery.cityName
                        }}-{{ item.address }}
                      </td>
                    </template>
                    <template
                      v-for="item in returnedOrder.returnOrderPartyInfoQueryDto
                        .returnOrderAddressesInfoQuery"
                    >
                      <td :key="item.id">
                        {{ item.postalCode }}
                      </td>
                    </template>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4>
                {{ $t("OrdersList") }}
                {{ $t("From") }}
                {{ $t("Contract") }}:
                <span class="color-primary">{{
                  returnedOrder.returnOrderContractQuery.contractTitle
                }}</span>
                <span class="date float-right">
                  <span> {{ $t("CreateOn") }}: </span>
                  <span class="float-right">
                    {{ returnedOrder.createOn }}
                  </span>
                </span>
              </h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl" id="draft-order-tbl">
              <vs-table
                :data="returnedOrder.returnOrdersItemsQueryDto"
                ref="table"
              >
                <template slot="thead">
                  <vs-th style="width: 3%">#</vs-th>
                  <vs-th style="width: 20%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width: 5%">{{ $t("Count") }}</vs-th>
                  <vs-th style="width: 12%">{{ $t("UnitPrice") }}</vs-th>
                  <vs-th style="width: 12%">{{ $t("TotalAmount") }}</vs-th>
                  <vs-th style="width: 12%">{{ $t("SumOfDiscount") }}</vs-th>
                  <vs-th style="width: 12%">{{ $t("TotalTaxAmount") }}</vs-th>
                  <vs-th style="width: 14%">{{
                    $t("TotalAmountWithTax")
                  }}</vs-th>
                  <vs-th style="width: 14%">{{ $t("Action") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td :data="data[indextr]">
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].returnOrderProductInfoQuery.productName
                      "
                    >
                      {{
                        data[indextr].returnOrderProductInfoQuery.productName
                      }}
                    </vs-td>
                    <vs-td :data="data[indextr].count">
                      {{ data[indextr].count ? data[indextr].count : "---" }}
                    </vs-td>
                    <vs-td :data="data[indextr].unitPrice">
                      {{ Number(data[indextr].unitPrice).toLocaleString() }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].totalAmount">
                      {{ Number(data[indextr].totalAmount).toLocaleString() }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].sumOfDiscount">
                      <span v-if="data[indextr].sumOfDiscount">
                        {{
                          Number(data[indextr].sumOfDiscount).toLocaleString()
                        }}
                        ریال
                      </span>
                      <span v-else> - </span>
                    </vs-td>
                    <vs-td :data="data[indextr].totalTaxAmount">
                      {{
                        Number(data[indextr].totalTaxAmount).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].price">
                      {{ Number(data[indextr].price).toLocaleString() }} ریال
                    </vs-td>
                    <vs-td :data="data[indextr].price">
                      <vs-button
                        color="primary"
                        type="border"
                        class="simple-bordered-btn"
                        @click.prevent="
                          showSerialsList(
                            tr.returnOrderProductInfoQuery.serializeSerial
                          )
                        "
                        >{{ $t("SerialNumbers") }}</vs-button
                      >
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <h5 class="text-left total-price">
                {{ $t("TotalAmountForPayment") }}:
                {{
                  Number(returnedOrder.totalAmountForPayment).toLocaleString()
                }}
                ریال
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <serials-list-popup
      :show="isShowSerialsList"
      :serialsList="serialsList"
      @finish="onfinish"
    ></serials-list-popup>
  </div>
</template>
<style lang="scss">
.date {
  font-size: 0.9rem;
  color: #626262;
  font-weight: normal;
}

.total-price {
  background-color: #c8c8c8;
  color: #58595b;
  padding: 1rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import SerialsListPopup from "./SerialsListPopup";

export default {
  name: "saleManagement_ReturnOrders_Details",
  data() {
    return {
      loadTable: false,
      isShowSerialsList: false,
      serialsList: []
    };
  },
  computed: {
    ...mapGetters({
      returnedOrder: "returnOrder/details",
      loading: "returnOrder/loading"
    })
  },
  components: {
    SerialsListPopup
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loadTable = true;
    }, 100);
  },
  methods: {
    ...mapActions({
      fetchSingle: "returnOrder/fetchSingle"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id);
    },
    showSerialsList(serialsList) {
      this.serialsList = serialsList;
      this.isShowSerialsList = true;
    },
    onfinish() {
      this.isShowSerialsList = false;
    }
  }
};
</script>
